import { Box } from '@strapi/design-system';

const RequiredSign = () => (
  <Box color="danger700" paddingLeft={1}>
    *
  </Box>
);

export { RequiredSign };
